import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";

// Whether the signed-in user is an admin. Only decides what to *show*: the
// admin data itself is protected by RLS, not by this flag.
export function useIsAdmin() {
  const { session, supabase } = useContext(AuthContext);
  const userId = session?.user?.id;
  const [state, setState] = useState({ isAdmin: false, loading: Boolean(userId) });

  useEffect(() => {
    if (!userId || !supabase) {
      setState({ isAdmin: false, loading: false });
      return undefined;
    }

    let cancelled = false;
    setState((current) => ({ ...current, loading: true }));
    supabase
      .from("users")
      .select("is_admin")
      .eq("auth_user_id", userId)
      .single()
      .then(({ data, error }) => {
        if (cancelled) return;
        setState({ isAdmin: !error && data?.is_admin === true, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ isAdmin: false, loading: false });
      });

    return () => {
      cancelled = true;
    };
  }, [userId, supabase]);

  return state;
}
